// extracted by mini-css-extract-plugin
module.exports = {"root":"_1eeNbu7","previous":"_3fOHs6C","next":"bHpQ-bp","page":"_1OJpAqA","page_isActive":"_1nM8M_g"};
    if(module.hot) {
      // 1545369435395
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  